"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_utilities_1 = require("@syl-editor/core-utilities");
var video_1 = require("@syl-editor/lib/dist/lib/formats/video");
var card_1 = require("../card");
var Icon = (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "20", viewBox: "0 0 24 24", width: "20" },
    react_1.default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
    react_1.default.createElement("path", { d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" })));
var VideoComponent = function (_a) {
    var attrs = _a.attrs;
    return (react_1.default.createElement("video", { src: attrs.src, height: attrs.height, width: attrs.width, style: {
            display: 'block',
            margin: 'auto'
        }, controls: true }));
};
var VideoSchema = /** @class */ (function (_super) {
    __extends(VideoSchema, _super);
    function VideoSchema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            mask: VideoComponent,
            template: VideoComponent
        };
        _this.renderer = _this.mount({ name: 'video' });
        return _this;
    }
    return VideoSchema;
}(card_1.Card));
var VideoController = /** @class */ (function (_super) {
    __extends(VideoController, _super);
    function VideoController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.toolbar.icon = Icon;
        return _this;
    }
    return VideoController;
}(video_1.VideoController));
var VideoPlugin = /** @class */ (function (_super) {
    __extends(VideoPlugin, _super);
    function VideoPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'video';
        _this.Controller = VideoController;
        return _this;
    }
    VideoPlugin.prototype.init = function (status, options) {
        this.Schema = core_utilities_1.configuration(video_1.getVideoConfiguration(options.controllerProps))(VideoSchema);
        _super.prototype.init.call(this, status, options);
    };
    return VideoPlugin;
}(core_utilities_1.SylPlugin));
exports.VideoPlugin = VideoPlugin;
//# sourceMappingURL=video.js.map